import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const inserirContaRedeSocial = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await api.post('/contasRedes/inserirConta', params, { headers });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao inserir conta em rede social';
    throw new Error(errorMessage);
  }
};

export const editarContaRedeSocial = async (id: number, params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/contasRedes/editar/${id}`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao editar conta';
    throw new Error(errorMessage);
  }
};

export const editarPublicacao = async (id: number, params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put(`/conteudo/editar/${id}`, params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao editar publicacao';
    throw new Error(errorMessage);
  }
};

export const deletarRelacionamentoConta = async (seqId: number) => {
  try {
    const response = await api.delete(`/conteudo/deletarConta?seqId=${seqId}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao deletar relacionamento de página';
    throw new Error(errorMessage);
  }
};

export const obterContaRedeSocial = async (id: number) => {
  try {
    const response = await api.get(`/contasRedes/obter/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter conta';
    throw new Error(errorMessage);
  }
};

export const listarContasRedesSociais = async (page: number, size: number, codRedeSocial: number) => {
  try {
    const response = await api.get(`/contasRedes/listar?pagina=${page}&tamanhoPagina=${size}&codRedeSocial=${codRedeSocial}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao listar contas';
    throw new Error(errorMessage);
  }
};

export const listarRedesSociais = async (page: number, size: number) => {
  try {
    const response = await api.get(`/config/redes/listar?pagina=${page}&tamanhoPagina=${size}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao listar os ícones de redes sociais';
    throw new Error(errorMessage);
  }
};

export const listarPublicacaoRedesSociais = async (
  codRede: number,
  pagina: number,
  tamanhoPagina: number,
  nomePublicacao?: string,
  situacao?: number,
  datPublicacaoInicio?: string,
  datPublicacaoFim?: string,
  datDespublicarInicio?: string,
  datDespublicarFim?: string
) => {
  const params = new URLSearchParams()
  params.append('codRede', codRede.toString());
  params.append('pagina', pagina.toString())
  params.append('tamanhoPagina', tamanhoPagina.toString())

  if (nomePublicacao) params.append('nomePublicacao', nomePublicacao)
    if (situacao !== undefined) 
      params.append('codSituacaoPubli', situacao.toString());
    
  if (datPublicacaoInicio)
    params.append('datPublicacaoInicio', datPublicacaoInicio)
  if (datPublicacaoFim) params.append('datPublicacaoFim', datPublicacaoFim)
  if (datDespublicarInicio)
    params.append('datDespublicarInicio', datDespublicarInicio)
  if (datDespublicarFim) params.append('datDespublicarFim', datDespublicarFim)

  const response = await api.get(`/conteudo/listarRedesSociais?${params.toString()}`)
  return response.data
}

export const obterListaFiltroSituacao = async () => {
  try {
    const response = await api.get(`/sitPublicacao`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter lista de situações';
    throw new Error(errorMessage);
  }
};

export const criarPublicacao = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.post('/conteudo/inserirPublicacao', params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const obterPublicacaoRedeSocial = async (id: any) => {
  try {
    const response = await api.get(`/conteudo/obter/${id}`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao obter publicação';
    throw new Error(errorMessage);
  }
};

export const inserirRedeSocialNoCdn = async (params: FormData) => {
  try {
    const response = await api.post('/files/upload', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const editarRedeSocialNoCdn = async (params: FormData) => {
  try {
    const response = await api.put('/files/update', params, {
      headers: {
        'Accept': '*/*'
      },
    });
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const deletarPublicacaoRedeSocialNoCdn = async (nomeArquivo: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.delete(`/files/${nomeArquivo}`, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};

export const deletarRedeSocial = async (id: any) => {
  try {
    const headers = {
      'Accept': '*/*'
    };
    const response = await api.delete(`/conteudo/${id}`, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao comunicar com o servidor';
    throw new Error(errorMessage);
  }
};